// src/components/Invoice.js


import React, { useState, useRef, useEffect } from 'react';
import { PageHeader, Row, Col, Table, Button, Modal, Image, notification, Spin } from 'antd';
import html2canvas from "html2canvas";
import { jsPDF } from 'jspdf';
import { Typography } from 'antd';
import { ToWords } from 'to-words';
import mainLogo from '../assets/images/brahmdhamtirth-logo.jpeg';
import babajiLogo from '../assets/images/brahmaavtar_guruji.jpeg';
import signLogo from '../assets/images/sign_pic.png';
import axios from "axios";
import { baseUrl } from "../config";


const { Title, Text } = Typography;


const toWords = new ToWords({
    localeCode: 'hi-IN',
    converterOptions: {
        currency: true,
        ignoreDecimal: true,
        ignoreZeroCurrency: false,
        doNotAddOnly: true,
        currencyOptions: {
            // can be used to override defaults for the selected locale
            name: 'रुपया',
            plural: 'रुपये',
            symbol: '₹',
            fractionalUnit: {
                name: 'Paisa',
                plural: 'Paise',
                symbol: '',
            },
        },
    },
});



const InvoiceView = ({ paymentId, btnShow = [], displayView = 'none',resetFxn = () => {}}) => {

    const imgContainerRef = useRef(null);
    const [loading, setLoading] = useState(false); // Loading state
    const [receiptStatus, setReceiptStatus] = useState(0);
    const [userData,setUserData] = useState(null);
    const [loader,setLoader] = useState(false);
    
    useEffect(async () => {
        if(paymentId && (displayView == "block" || btnShow.includes('whatsappSend')))
        {
            let statusData = await fetchUserDetails(paymentId);
            if(btnShow.includes('whatsappSend') && statusData)
            {
                exportImagePdf(statusData, "whatsappSend")
            }
        }
        
    },[paymentId,displayView]);

    const fetchUserDetails = async (paymentIdKey) => {
        setLoader(true)
        try {
            if(paymentIdKey)
            {

                const response = await axios.get(`${baseUrl}/payments/read/${paymentIdKey}`, {
                    headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                    },
                });
                console.log("STA  ",response?.data?.result)
                if (response?.data?.status == true) {
                    // setRoleData(response.data.result);
                    await setUserData(response?.data?.result);
                    setReceiptStatus(response?.data?.result?.reciept_status)
                    setLoader(false)
                    return response?.data?.result;
                } else {
                    setLoader(false)
                    return false;
                }

            }
            else{
                setLoader(false)
                return false;
            }
        } catch (error) {
          console.error("API error:", error);
          setLoader(false)
          return false;
        }
      };

    const buttonActionsCall = async (e,paymentVal,btnType='') =>
    {
        
        let statusData = await fetchUserDetails(paymentVal);
        
        if(statusData)
        {
            exportImagePdf(statusData, btnType)
        }
    }
    async function exportImagePdf(userReData, type = "img") {

        let title=  userReData?.name_eng || "certificate";
        if (imgContainerRef.current) {

            imgContainerRef.current.style.display = 'block';
            imgContainerRef.current.style.position = 'fixed';
            imgContainerRef.current.style.top = '-9999px';
            imgContainerRef.current.style.left = '-9999px';
            imgContainerRef.current.style.width = '1400px';
            imgContainerRef.current.style.zIndex = '-1';

            // Let browser re-render with latest data and lay out at the fixed width
            await new Promise(resolve => setTimeout(resolve, 200));

            const { offsetWidth, offsetHeight } = imgContainerRef.current;

            const resetStyles = () => {
                imgContainerRef.current.style.display = 'none';
                imgContainerRef.current.style.position = '';
                imgContainerRef.current.style.top = '';
                imgContainerRef.current.style.left = '';
                imgContainerRef.current.style.width = '';
                imgContainerRef.current.style.zIndex = '';
            };

            html2canvas(imgContainerRef.current, {
                width: offsetWidth,
                height: offsetHeight,
                scale: 2,
                useCORS: true,
            }).then((canvas) => {
                resetStyles();

                const chartImage = canvas.toDataURL("image/jpeg", 1.0); // Use JPEG format for the image
                let nameTitle = (title.replace(/\s/g, '-') || "Invoice") + "-contribution";
                if (type === "pdf") {
                    // Generate PDF
                    const pdf = new jsPDF(
                        {
                            orientation: 'landscape',
                            unit: 'mm',
                            format: 'a5'
                        }
                    );
                    pdf.addImage(chartImage, "JPEG", 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
                    pdf.save(nameTitle);

                }
                else if (type === "pdfprint") {
                    const pdf = new jsPDF(
                        {
                            orientation: 'landscape',
                            unit: 'mm',
                            format: 'a5'
                        }
                    );
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = pdf.internal.pageSize.getHeight();
                    pdf.addImage(chartImage, "JPEG", 0, 0, pdfWidth, pdfHeight);

                    // Convert PDF to Blob
                    const blob = pdf.output('blob');

                    // Create URL for the Blob
                    const url = URL.createObjectURL(blob);

                    // Open the PDF in a new window/tab
                    var newWindow = window.open(url, '_blank');
                    if (newWindow) {
                        newWindow.onload = function () {
                            newWindow.print();
                        };
                    }
                }
                else if (type == "whatsapp" || type =="whatsappSend") {
                    // Modal.confirm({
                    //     title: 'Are you sure you want to send this receipt?',
                    //     onOk: async () => {
                           // setLoading(true); // Show loader
                            const pdf = new jsPDF(
                                {
                                    orientation: 'landscape',
                                    unit: 'mm',
                                    format: 'a5'
                                }
                            );
                            const pdfWidth = pdf.internal.pageSize.getWidth();
                            const pdfHeight = pdf.internal.pageSize.getHeight();
                            pdf.addImage(chartImage, "JPEG", 0, 0, pdfWidth, pdfHeight);

                            // Convert PDF to Blob
                            const blob = pdf.output('blob');

                            // Convert Blob to Base64
                            const reader = new FileReader();
                            reader.onloadend = function () {
                                const base64String = reader.result.split(',')[1]; // Get base64 string
                                sendWhatsAppMessage(base64String, nameTitle,userReData);
                            };
                            reader.readAsDataURL(blob);

                            if(type == "whatsappSend")
                            {
                              //  resetFxn(null);
                            }
                      //  },
                  //  });

                }
                else {

                    // Create a link and download the image
                    const link = document.createElement("a");
                    link.href = chartImage;
                    link.download = nameTitle + '.png';
                    link.click();
                }
            }).catch(error => {
                console.error('Error rendering image:', error);
                resetStyles();
            });
        }
    }

    const sendWhatsAppMessage = (pdfBase64, fileName,userReData) => {
        //send over whatsapp
        const dataUser = {
            phoneNumber: userReData?.phone_no,
            pdfBase64: pdfBase64,
            filename: fileName,
            mimeType: 'application/pdf',
            userId: userReData?.user_id,
            name: userReData?.name_hn || userReData?.name_eng,
            payment_id: userReData?.payment_id,
        };
        console.log('dataUser--',dataUser)

        try {
            const response = axios.post(`${baseUrl}/send-message/whatsapp-message`, dataUser, {
                //const responsePost =  axios.post(`http://localhost:3000/send-message/whatsapp-message`,dataUser, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            }).then((response) => {

                console.log('response--',response)

                if (response.status === 200) {

                    notification.info({
                        message: 'Success',
                        description: "Message sent successfully.",
                        placement: 'topRight'
                    });
                    setReceiptStatus(1);
                    resetFxn(null);

                } else {
                 
                    notification.info({
                        message: 'Info',
                        description: response?.data?.message,
                        placement: 'topRight'
                    });
                    resetFxn(null);

                }
            }).catch((error) => {
                console.error("API error:", error);
                notification.info({
                    message: 'Info',
                    description: error.response?.data?.message,
                    placement: 'topRight'
                });
                resetFxn(null);
            });


        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
            resetFxn(null);
        }
        finally {
            setLoading(false); // Hide loader
        }
    }



    const formatDate = (dateString) => {
        if (dateString && dateString !== "undefined") {
            const date = new Date(dateString);

            // Get year
            const year = date.getFullYear();

            // Get month short name (e.g., Jan, Feb, Mar, etc.)
            const monthShortName = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);

            // Get date
            const day = date.getDate();

            // Format the output string
            const formattedDate = `${day}-${monthShortName}-${year}`;

            return formattedDate;
        }
        else {
            return dateString;
        }
    };

    const vartmaan = () => {
        if (userData?.tem_district_hn) {
            return userData?.tem_district_hn;
        }
        else if (userData?.tem_district_en) {
            return userData?.tem_district_en;
        }
        else if (userData?.per_district_hn) {
            return userData?.per_district_hn;
        }
        else {
            return userData?.per_district_en || '';
        }
    }
   


    return (
        <>
            <div style={{border: '2px solid #b04e4f', padding: '10px', display: displayView }} ref={imgContainerRef}>
                <div style={{  marginTop: '10px', marginBottom: '15px' }} >
                    <div style={{ padding: '10px 10px' }}>


                        {/* Row 2 */}
                        <Row gutter={[16, 16]} style={{ marginTop: '0px' }}>
                            <Col span={4} style={{ textAlign: 'center' }}>
                                <img height={150}  alt='' src={mainLogo} />

                                <div style={{  marginTop: '30px', display: 'block' }}> 
                                <Text level={3} style={{ fontSize: '14px',lineHeight:2,backgroundColor : "#FFFF00" }} className='d-block InvoiceLeft'>ब्रह्मर्षि <br /> ब्रह्माचार्य ब्रह्मा <br /> सावित्री सिद्ध <br /> पीठाधीश्वर श्री <br />तुलछारामजी महाराज <br /> अध्यक्ष</Text>
                                </div>
                            </Col>

                            <Col span={16} style={{ textAlign: 'center' }} className='invoiceTopHead'>
                                <Row className='inVoiceheader' style={{backgroundColor : "#FFFF00", padding : "18px"}}>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Title style={{ fontSize: '14px',margin: 0 }} level={5} >|| ॐ ब्रह्मणे नमः ||</Title>
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Title style={{ fontSize: '14px',margin: 0 }} level={5} >|| श्री गणेशाय नम: ||</Title>
                                    </Col>
                                    <Col span={8} style={{ textAlign: 'center' }}>
                                        <Title style={{ fontSize: '14px',margin: 0 }} level={5} >|| श्री खेतेश्वराय नमः ||</Title>
                                    </Col>
                                </Row>

                                <div style={{ marginBottom: '30px', marginTop: '60px', display: 'block' }}>  
                                <Title style={{ fontSize: '16px', marginBottom: "10px", display: 'block' }} level={3}>श्री ब्रह्मर्षि ब्रह्माचार्य श्री श्री तुलछारामजी महाराज की सत्प्रेरणा से</Title>
                                </div>
                                <div style={{ marginBottom: '10px', marginTop: '60px', display: 'block' }}>  
                                <Title level={2} style={{ marginTop: 0, fontSize: '20px', display: 'block' }}>अखिल भारतीय राजपुरोहित समाज विकास संस्थान आसोतरा</Title>
                                </div>
                                <div style={{ marginBottom: '10px', marginTop: '20px', display: 'block' }}>  
                                <Title style={{ marginTop: 0, marginBottom: "10px",padding : "10px", fontSize: '25px', display: 'block',backgroundColor : "#FFFF00"  }}>समाज शिक्षा निधि समर्पण योजना</Title>
                                </div>
                                <div style={{ marginBottom: '10px', marginTop: '20px', display: 'block' }}>  
                                <Title style={{ fontSize: '20px', marginTop: 0, marginBottom: "10px", display: 'block' }} level={3}>प्रधान कार्यालय:- श्री खेतेश्वर ब्रह्मधाम तीर्थ आसोतरा, जिला बाड़मेर (राज.)</Title>
                                </div>
                                <div style={{ marginBottom: '10px', marginTop: '20px', display: 'block' }}>  
                                <Title style={{ fontSize: '20px', marginTop: 0, padding : "10px", marginBottom: "10px", display: 'block' }}  level={3}>रजि नं. 57/1997-98/22-12-1997 </Title>
                                <Title style={{ fontSize: '20px', marginTop: 0, padding : "10px", marginBottom: "10px", display: 'block',backgroundColor : "#FFFF00" }}  level={3}>PAN No. AAATA2501N</Title>
 
                                </div>
                               
                            </Col>


                            <Col span={4} style={{ textAlign: 'center' }}>
                                <img height={150}  style={{ borderRadius: '4px' }}   alt='' src={babajiLogo} />

                                <div style={{  marginTop: '30px', display: 'block' }}> 
                                <Text style={{ fontSize: '16px',lineHeight:2,backgroundColor : "#FFFF00" }} className='d-block InvoiceLeft'>ब्रह्मर्षि श्री <br /> खेतारामजी <br /> महाराज संस्थापक  </Text>
                                <Text style={{ fontSize: '16px',lineHeight:2,backgroundColor : "#FFFF00" }} className='d-block InvoiceLeft'>ब्रह्मचारी वेदान्ताचार्य  <br /> डॉ. ध्यानारामजी  <br /> (कार्यकारी अध्यक्ष)  </Text>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={[16, 16]} style={{ marginTop: '30px' }}>
                            <Col span={12}>
                                <Title style={{ fontSize: '18px' ,color: '#ff0000' }} level={5}><strong>रसीद नं :</strong> <span style={{ paddingLeft: '5px' }}>{userData?.receipt_no}</span></Title>
                            </Col>
                            <Col span={12} style={{ textAlign: 'right' }}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>दिनांक :</strong> <span style={{ paddingLeft: '5px' }}>{userData?.pyament_mode_type == "Cash" ? formatDate(userData?.payment_entry_date) : formatDate(userData?.transaction_date)}</span></Title>
                            </Col>
                        </Row>

                        <Row gutter={[16, 16]} style={{ marginTop: '10px' }} className='InvoiceForm'>
                            <Col span={8}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>श्रीमान् :</strong> <span>{userData?.name_hn ? userData?.name_hn : userData?.name_eng}</span></Title>
                            </Col>
                            <Col span={8}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>{userData?.relation_hn} </strong>: <span>{userData?.father_name_hn ? userData?.father_name_hn : userData?.father_name_en}</span></Title>
                            </Col>
                            <Col span={8}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>गांव :</strong> <span>{userData?.per_village_hn ? userData?.per_village_hn : userData?.per_village_en}</span></Title>
                            </Col>
                            <Col span={8}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>तहसील :</strong> <span>{userData?.per_tahsil_hn ? userData?.per_tahsil_hn : userData?.per_tahsil_en}</span></Title>
                            </Col>
                            <Col span={8}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>जिला :</strong> <span>{userData?.per_district_hn ? userData?.per_district_hn : userData?.per_district_en}</span></Title>
                            </Col>
                            <Col span={8}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>राज्य :</strong> <span>{userData?.per_state_hn ? userData?.per_state_hn : userData?.per_state_en}</span></Title>
                            </Col>
                            <Col span={12}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>वर्तमान :</strong> <span>{userData?.tem_district_hn ? userData?.tem_district_hn : userData?.tem_district_en}</span></Title>
                            </Col>
                            <Col span={12}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>रुपये :</strong> <span>{userData?.amount ? userData?.amount + '/-' : ''}</span></Title>
                            </Col>
                            <Col span={12}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>अक्षरे रुपये :</strong> <span>{userData?.amount ? toWords.convert(userData?.amount) : ''} मात्र</span></Title>
                            </Col>

                            <Col span={12}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>रोकड़/चैक/UPI/ RTGS/ :</strong> </Title>
                            </Col>
                            <Col span={12}>
                                <Title style={{ fontSize: '18px' }} level={5}> <span>{ (userData?.pyament_mode_type == "UPI" || userData?.pyament_mode_type =="Cheque" || userData?.pyament_mode_type =="RTGS-NEFT") ? userData?.pyament_mode_type + '-' + userData?.utr_number : userData?.pyament_mode_type}</span></Title>
                            </Col>
                            
                            <Col span={24}>
                                <Title style={{ fontSize: '18px' }} level={5}><strong>से समाज शिक्षा निधि समर्पण योजना के तहत सधन्यवाद प्राप्त हुए।</strong></Title>
                            </Col>
                        </Row>

                        <Row gutter={[16, 16]} style={{ marginTop: '0px', marginBottom: '10px', alignItems: 'end' }} className='Invoicelast'>
                            <Col span={8}>
                                <div className='rupeesBox'>
                                    <i>₹</i><span style={{ marginLeft: '10px', fontSize: '25px', fontWeight: 600, fontStyle: 'italic' }}>{userData?.amount}/-</span>
                                </div>
                            </Col>
                            <Col span={8} className='text-center'>

                                <Title  style={{ fontSize: '11px' }} level={4} className='text-center'>हस्ताक्षर देनेवाला </Title>
                                <div className='InvoiceForm'>
                                    <Title  style={{ fontSize: '16px' }} level={5}><i>संपर्क सूत्र:</i> <span style={{ fontSize: '16px' }}>{userData?.phone_no || '      '}</span></Title>
                                </div>
                            </Col>
                            <Col span={8} className='text-center'>
                                <img height={50} alt='' src={signLogo} />
                                <Title  style={{ fontSize: '11px' }} level={4} className='text-center mt-2'>हस्ताक्षर प्राप्तकर्ता </Title>
                                <div className='InvoiceForm'>

                                    <Title  style={{ fontSize: '16px' }}  level={5}><i>संपर्क सूत्र:</i> <span style={{ fontSize: '16px' }}>7023131008, 9030301008</span></Title>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className='inVoiceFooter' style={{backgroundColor : "#FFFF00"}}>
                        <Row>
                            <Col span={8}>
                                <Title style={{ fontSize: '14px' }}  level={5}>Website : <span>www.brahmdhamtirth.org</span></Title>
                            </Col>
                            <Col span={8}>
                                <Title style={{ fontSize: '14px' }}  level={5}>E-mail : <span>asotra@brahmdhamtirth.org</span></Title>
                            </Col>
                            <Col span={8}>
                                <Title style={{ fontSize: '14px' }}   level={5}>Phone : <span>7023131008, 9030301008</span></Title>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
            

                {btnShow.includes('img_download') &&
                    <>
                    {loader ? <Spin /> :
                    <Button style={{ marginRight: '5px' }} onClick={(e) => buttonActionsCall(e,paymentId)}>Image Download</Button>
                    }
                    </>
                }
                {btnShow.includes('pdf_download') &&
                    <>
                    {loader ? <Spin /> :
                    <Button style={{ marginRight: '5px' }} onClick={(e) => buttonActionsCall(e,paymentId, 'pdf')}>PDF Download</Button>
                    }
                    </>
                }
                {btnShow.includes('pdf_print') &&
                    <>
                    {loader ? <Spin /> :
                    <Button style={{ marginRight: '5px' }} onClick={(e) => buttonActionsCall(e, paymentId,'pdfprint')}>PDF Print</Button>
                    }
                    </>
                }
                {btnShow.includes('whatsapp') &&
                    <>
                    {loader ? <Spin /> :
                    <Button title="Send" color="blue" onClick={(e) => buttonActionsCall(e,paymentId, 'whatsapp')}>
                          {receiptStatus === 1 ? 'Re-send Receipt' : 'Send Receipt'}

                    </Button>
                    }
                    </>
                }


           

            <style>
                {`
              .ant-spin-container {   float: left; }
               }
               `}
            </style>

        </>
    );


};

export default InvoiceView;